import { PayHeader } from "../Paymentheader/PayHeader";
import "./credit.css";
import { Button, Result, message, Card } from "antd";
import { useSelector, useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import { useState } from "react";
import { KYC_Status_car, Policy_PDF } from "../../Redux/actions/NumCaration";
export const CarCredit = () => {
  const dispatch = useDispatch();
  let PolicyDwnld = useSelector(
    (state) => state?.cardetail?.createProposal?.data
  );
  let KYCData = useSelector((state) => state?.cardetail?.KycStatus?.data);
  const carNum = useSelector((state) => state?.cardetail?.carnum);
  const SelectedQQ = useSelector((state) => state?.common?.selectedQuote);
  //let PolicyDwnld = JSON.parse(localStorage.getItem("create_proposal"));
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  //   console.log(PolicyDwnld)

  // console.log(KYCData)
  const handleKYC = () => {
    setLoading(true);
    let post = {
      policyNumber: PolicyDwnld?.policyNumber,
    };

    axiosInCar
      .post(
        `v2/car_insurances/${carNum?.car_insurance_id}/insurers/${SelectedQQ?.provider}/kyc_status`,
        post
      )
      .then((res) => {
        // console.log(res)
        let data = res.data;
        // console.log(data)
        dispatch(KYC_Status_car(data));
        let KYCLink = data?.data?.link;
        // console.log(KYCLink)
        if (KYCLink) {
          window.open(KYCLink, "_blank");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response);
        message.error(err.response.data.error);
        setLoading(false);
      });
  };

  const handleButton = () => {
    setLoading(true);
    let post = {
      policyId: PolicyDwnld?.applicationId,
    };
    // v2/bike_insurances/{insurance}/insurers/{insurer}/pdf_generation

    axiosInCar
      .post(
        `v2/car_insurances/${carNum?.car_insurance_id}/insurers/${SelectedQQ?.provider}/pdf_generation`,
        post
      )
      .then((res) => {
        // console.log(res)
        let data = res.data;
        // console.log(data.data.schedulePath)
        window.open(data.data.schedulePath, "_blank");
        dispatch(Policy_PDF(data));
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response.data);
        message.error(err.response.data.error.errorMessage);
        setLoading(false);
      });
  };

  return (
    <>
      <PayHeader />
      <div className="row justify-content-center py-3">
        {KYCData?.kycVerificationStatus === "DONE" ? (
          <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
            <Result
              status="success"
              title="You have successfully Verified KYC"
              subTitle={`Quote No: ${PolicyDwnld?.policyNumber}`}
              extra={[
                <Button
                  loading={loading}
                  onClick={handleButton}
                  type="primary"
                  key="console"
                >
                  Download Policy
                </Button>,
              ]}
            />
          </Card>
        ) : (
          <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
            <Result
              status="warning"
              title="Verify Your KYC Satus"
              subTitle={`Quote No: ${PolicyDwnld?.policyNumber}`}
              extra={[
                <Button
                  loading={loading}
                  onClick={handleKYC}
                  type="primary"
                  key="console"
                >
                  Click to Verify KYC Status
                </Button>,
              ]}
            />
          </Card>
        )}
      </div>
      <div className="footter-md-cnfrm">
        <div className="footter-md-1">
          <p>
            Registration No. 742, Registration Code No. IRDA/ DB 797/ 19, Valid
            till 09/06/2024, License category- Direct Broker (Life & General)
          </p>
          <p> solely based on the information received from the insurers.</p>
        </div>
        <div className="footer-md-2">
          <p>@Copyright 2018-2024</p>
          <p>
            <a href="www.VIBE.com">VIBE</a>
          </p>
          <p>All rights reserved</p>
        </div>
      </div>
    </>
  );
};
